import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { SharedModule } from 'src/app/shared/shared.module';

import { OrganizationRoutingModule } from './organization.routing';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { OrganizationPostsComponent } from './posts/posts.component';

// TODO: refactor
// remove this internal store
import { organizationKey } from './store/organization.actions';
import { organizationReducer } from './store/organization.reducer';
import { OrganizationEffects } from './store/organization.effects';

import { postsFeatureKey } from '../../shared/ui/post/data/store/state';
import { postsReducer } from '../../shared/ui/post/data/store/reducer';
import { PostEffects } from '../../shared/ui/post/data/store/effects';
import { OrganizationComponent } from './organization.component';
import { OrganizationUpdatesComponent } from './organization-updates/organization-updates.component';
import { OrganizationAboutComponent } from './organization-about/organization-about.component';
import { OrganizationMembersComponent } from './organization-members/organization-members.component';
import { OrganizationGroupsComponent } from './organization-groups/organization-groups.component';
import { OrganizationJobsComponent } from './organization-jobs/organization-jobs.component';
import { OrganizationNewJob } from './organization-new-job/organization-new-job.component';
import { OrgnizationRefencesComponent } from './organization-references/organization-references.component';
import { OrganizationProfileComponent } from './organization-profile/organization-profile.component';

@NgModule({
  declarations: [
    OrganizationComponent,
    OrganizationPostsComponent,
    OrganizationUpdatesComponent,
    OrganizationAboutComponent,
    OrganizationMembersComponent,
    OrganizationGroupsComponent,
    OrganizationJobsComponent,
    OrganizationNewJob,
    OrgnizationRefencesComponent,
    OrganizationProfileComponent
  ],
  imports: [
    InfiniteScrollModule,
    CommonModule,
    SharedModule,
    OrganizationRoutingModule,
    StoreModule.forFeature(organizationKey, organizationReducer),
    StoreModule.forFeature(postsFeatureKey, postsReducer),
    EffectsModule.forFeature([OrganizationEffects, PostEffects])
  ]
})
export class OrganizationModule {}
